import {
  IAddNewData,
  ISearchParameters,
  ITableReport,
} from "./TableInterfaces";

export interface ISahraTableSearchParams extends ISearchParameters {
  justActive?: boolean;
  name?: string;
  username?: string;
  exchangeType?: ExchangeType;
}

export interface ISahraTableReports extends ITableReport {
  name: string;
  userName: string;
  createdDate: string;
  url: string;
  isActive: boolean;
  canTrade: boolean;
}

export interface IAddOrEditSahraUser extends IAddNewData {
  id?: number;
  name: string;
  username: string;
  password: string;
  link: string;
  connectedSahraUserId: string;
  sahraUserGroupIds: number[];
}

export enum ExchangeType {
  CommodityExchange = 1,
  StockExchange = 2,
}
